import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * Route-level guard: screens outside the supported mobile scope redirect
 * away on phones. Covers deep links and bookmarks — the drawer nav trim
 * only hides links, this makes the routes actually unreachable.
 *
 * `to` — redirect target (default /projects for authed screens; public
 * marketing pages pass /login).
 *
 * Desktop renders children untouched.
 */
const MobileGate = ({ children, to = '/projects' }) => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return <Navigate to={to} replace />;
  }
  return children;
};

export default MobileGate;
